import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Digits, Title } from '../../common';

const Description = styled.p`
  font-size: 0.9375rem;
  margin-bottom: 44px;
`;

export default function CurrentPassword({ onChange, values, color }) {
  return (
    <>
      <Title marginBottom="26px">Alterar senha</Title>
      <Description>Você lembra da sua atual?</Description>
      <Digits
        type="password"
        label="Informe a senha do cartão"
        onChange={objValue => onChange(objValue, 'password')}
        values={values}
        color={color}
      />
    </>
  );
}

CurrentPassword.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object,
};
